/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   STANDARD OPTION CARDS

   Görev:
   - Paint dışındaki ürünlerde dropdown yerine kart kullanır
   - Gerçek Shopify select tek source of truth olarak kalır
   - Kart tıklanınca native select değiştirilir
   - Native select change eventi Core JS'i tetikler
   - Core gerçek Shopify varyantını bulur
   - Variant ID / fiyat / stok / URL / buybox Core tarafından güncellenir
   - Kart fiyatları / stok / indirim / görseller bu modül tarafından güncellenir

   ÖNEMLİ:
   Bu dosya kendi başına DOMContentLoaded çalıştırmaz.

   Başlatma:
   assets/dekofar-v2-init.js

   Gereksinim:
   assets/dekofar-v2-core.js
========================================================= */

(function dekofarV2StandardOptionsBootstrap(
  window,
  document
) {

  'use strict';



  /* =======================================================
     HELPER
  ======================================================= */

  function normalizeValue(value) {

    return String(
      value === undefined ||
      value === null
        ? ''
        : value
    ).trim();

  }



  /* =======================================================
     MAIN INITIALIZER
  ======================================================= */

  function dekofarV2InitStandardOptions(
    scope
  ) {

    const root =
      scope &&
      typeof scope.querySelectorAll ===
        'function'
        ? scope
        : document;



    /* =====================================================
       SELECTOR ROOTLARI BUL

       Scope doğrudan selector olabilir.
       Ya da selector scope içinde olabilir.
    ===================================================== */

    const selectors = [];


    if (
      root.matches &&
      root.matches(
        '[data-dekofar-v2-standard-selector]'
      )
    ) {

      selectors.push(
        root
      );

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '[data-dekofar-v2-standard-selector]'
        )
        .forEach(
          (selector) => {

            selectors.push(
              selector
            );

          }
        );

    }



    /* =====================================================
       HER STANDARD SELECTOR
    ===================================================== */

    selectors.forEach(
      (selector) => {



        /* =================================================
           DUPLICATE INIT KORUMASI
        ================================================= */

        if (
          selector.dataset
            .dekofarV2StandardInitialized ===
          'true'
        ) {

          return;
        }



        /* =================================================
           OPTION WRAPPER
        ================================================= */

        const optionWrapper =
          selector.closest(
            '[data-dekofar-v2-option]'
          );


        const productRoot =
          selector.closest(
            '.dekofar-v2-product'
          );


        if (
          !optionWrapper ||
          !productRoot
        ) {

          console.warn(
            'Dekofar V2 Standard: option wrapper veya product root bulunamadı.',
            selector
          );

          return;
        }



        /* =================================================
           GERÇEK SHOPIFY SELECT
        ================================================= */

        const select =
          optionWrapper.querySelector(
            'select[data-option-position]'
          );



        /* =================================================
           STANDARD KARTLAR
        ================================================= */

        const buttons = [
          ...selector.querySelectorAll(
            '[data-dekofar-v2-standard-value]'
          )
        ];


        if (
          !select ||
          !buttons.length
        ) {

          console.warn(
            'Dekofar V2 Standard: native select veya kart bulunamadı.',
            optionWrapper
          );

          return;
        }



        /* =================================================
           PRODUCT JSON

           Core helper kullanılır.
        ================================================= */

        if (
          typeof window.dekofarV2ReadProductData !==
            'function' &&
          typeof dekofarV2ReadProductData !==
            'function'
        ) {

          console.error(
            'Dekofar V2 Standard: dekofarV2ReadProductData bulunamadı. core.js yüklenmiş olmalı.'
          );

          return;
        }


        const readProductData =
          typeof window.dekofarV2ReadProductData ===
            'function'
            ? window.dekofarV2ReadProductData
            : dekofarV2ReadProductData;


        const productData =
          readProductData(
            productRoot
          );


        if (
          !productData ||
          !Array.isArray(
            productData.variants
          )
        ) {

          console.error(
            'Dekofar V2 Standard: ürün JSON verisi okunamadı.'
          );

          return;
        }



        /* =================================================
           TÜM GERÇEK OPTION SELECTLER

           Core ile aynı şekilde:
           data-option-position değerine göre sıralanır.
        ================================================= */

        const allOptionSelects = [
          ...productRoot.querySelectorAll(
            '[data-dekofar-v2-variants] select[data-option-position]'
          )
        ]
          .filter(
            (optionSelect) => {

              const position =
                parseInt(
                  optionSelect.getAttribute(
                    'data-option-position'
                  ),
                  10
                );


              return (
                Number.isFinite(
                  position
                ) &&
                position >= 1
              );

            }
          )
          .sort(
            (
              a,
              b
            ) => {

              const positionA =
                parseInt(
                  a.getAttribute(
                    'data-option-position'
                  ),
                  10
                );


              const positionB =
                parseInt(
                  b.getAttribute(
                    'data-option-position'
                  ),
                  10
                );


              return (
                positionA -
                positionB
              );

            }
          );


        if (
          !allOptionSelects.length
        ) {

          return;
        }



        /* =================================================
           BU OPTION'IN SHOPIFY POSITION'I
        ================================================= */

        const optionPosition =
          parseInt(
            select.getAttribute(
              'data-option-position'
            ),
            10
          );


        if (
          !Number.isFinite(
            optionPosition
          ) ||
          optionPosition < 1
        ) {

          return;
        }


        const optionIndex =
          optionPosition - 1;



        /* =================================================
           SELECTED VALUE ELEMENT
        ================================================= */

        const selectedValueElement =
          optionWrapper.querySelector(
            '[data-dekofar-v2-standard-selected-value]'
          );



        /* =================================================
           CORE HELPERS
        ================================================= */

        const findVariant =
          typeof window.dekofarV2FindVariant ===
            'function'
            ? window.dekofarV2FindVariant
            : (
                typeof dekofarV2FindVariant ===
                  'function'
                  ? dekofarV2FindVariant
                  : null
              );


        const formatMoney =
          typeof window.dekofarV2FormatMoney ===
            'function'
            ? window.dekofarV2FormatMoney
            : (
                typeof dekofarV2FormatMoney ===
                  'function'
                  ? dekofarV2FormatMoney
                  : null
              );


        const getCompareAtPrice =
          typeof window.dekofarV2GetCompareAtPrice ===
            'function'
            ? window.dekofarV2GetCompareAtPrice
            : (
                typeof dekofarV2GetCompareAtPrice ===
                  'function'
                  ? dekofarV2GetCompareAtPrice
                  : null
              );


        const getFeaturedMediaId =
          typeof window.dekofarV2GetFeaturedMediaId ===
            'function'
            ? window.dekofarV2GetFeaturedMediaId
            : (
                typeof dekofarV2GetFeaturedMediaId ===
                  'function'
                  ? dekofarV2GetFeaturedMediaId
                  : null
              );



        /* =================================================
           FALLBACK MONEY FORMAT
        ================================================= */

        const money =
          (amount) => {


            if (
              formatMoney
            ) {

              return formatMoney(
                amount
              );
            }


            const number =
              Number(
                amount
              );


            if (
              !Number.isFinite(
                number
              )
            ) {

              return '';
            }


            return (
              new Intl.NumberFormat(
                'tr-TR',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ).format(
                number /
                100
              ) + ' TL'
            );

          };


        /* =================================================
           CART DISCOUNT CAMPAIGN
           1.500 TL ve üzeri ürünlerde sepette 200 TL indirim.
           Bu sadece kart üzerindeki bilgilendirmedir; gerçek
           Shopify varyant fiyatına dokunulmaz.
        ================================================= */

        const cartDiscountEnabled =
          productData.cart_discount_enabled !== false;

        const cartDiscountThreshold =
          Number(productData.cart_discount_threshold || 150000);

        const cartDiscountType =
          String(productData.cart_discount_type || 'fixed');

        const cartDiscountValue =
          Number(productData.cart_discount_value || 200);

        const cartDiscountAmount =
          Number(productData.cart_discount_amount || Math.round(cartDiscountValue * 100));

        const hasCartDiscountCampaign =
          (price) => {
            const numericPrice = Number(price);

            if (
              !cartDiscountEnabled ||
              !Number.isFinite(numericPrice) ||
              !Number.isFinite(cartDiscountThreshold) ||
              numericPrice < cartDiscountThreshold ||
              !Number.isFinite(cartDiscountValue) ||
              cartDiscountValue <= 0
            ) {
              return false;
            }

            if (cartDiscountType === 'percentage') {
              return cartDiscountValue < 100;
            }

            return (
              Number.isFinite(cartDiscountAmount) &&
              cartDiscountAmount > 0 &&
              numericPrice > cartDiscountAmount
            );
          };

        const cartDiscountPrice =
          (price) => {
            const numericPrice = Number(price);

            if (!hasCartDiscountCampaign(numericPrice)) {
              return numericPrice;
            }

            if (cartDiscountType === 'percentage') {
              return Math.max(
                0,
                Math.round(numericPrice * (100 - cartDiscountValue) / 100)
              );
            }

            return numericPrice - cartDiscountAmount;
          };

        const cartDiscountBadgeText =
          () => {
            if (cartDiscountType === 'percentage') {
              return `%${new Intl.NumberFormat('tr-TR').format(cartDiscountValue)} İNDİRİM`;
            }

            return `${new Intl.NumberFormat('tr-TR').format(cartDiscountValue)} TL İNDİRİM`;
          };


        /* =================================================
           SELECTED OPTIONS

           Shopify position'a göre array oluşturulur.

           position 1 -> [0]
           position 2 -> [1]
        ================================================= */

        const getSelectedOptions =
          () => {


            const selectedOptions =
              [];


            allOptionSelects.forEach(
              (optionSelect) => {


                const position =
                  parseInt(
                    optionSelect.getAttribute(
                      'data-option-position'
                    ),
                    10
                  );


                if (
                  !Number.isFinite(
                    position
                  ) ||
                  position < 1
                ) {

                  return;
                }


                selectedOptions[
                  position - 1
                ] =
                  optionSelect.value;

              }
            );


            return selectedOptions;

          };



        /* =================================================
           VARIANT BUL

           Mevcut diğer seçimler korunur.
           Yalnızca bu kartın option değeri değiştirilir.
        ================================================= */

        const findVariantForValue =
          (value) => {


            const candidateOptions =
              getSelectedOptions();


            candidateOptions[
              optionIndex
            ] =
              value;



            /* ---------------------------------------------
               CORE VARIANT FINDER
            --------------------------------------------- */

            if (
              findVariant
            ) {

              const variant =
                findVariant(
                  productData,
                  candidateOptions
                );


              if (
                variant
              ) {

                return variant;
              }

            }



            /* ---------------------------------------------
               FALLBACK
            --------------------------------------------- */

            return (
              productData.variants.find(
                (variant) => {


                  if (
                    !variant ||
                    !Array.isArray(
                      variant.options
                    )
                  ) {

                    return false;
                  }


                  return variant.options.every(
                    (
                      variantOption,
                      index
                    ) => {

                      return (
                        normalizeValue(
                          variantOption
                        ) ===
                        normalizeValue(
                          candidateOptions[
                            index
                          ]
                        )
                      );

                    }
                  );

                }
              ) ||
              null
            );

          };



        /* =================================================
           FREE SHIPPING
        ================================================= */

        const freeShippingLimit =
          Number.isFinite(
            Number(
              productData.free_shipping_limit
            )
          )
            ? Number(
                productData.free_shipping_limit
              )
            : 75000;


        const variantHasFreeShipping =
          (variant) => {


            if (
              !variant
            ) {

              return false;
            }


            if (
              typeof variant.free_shipping ===
              'boolean'
            ) {

              return variant.free_shipping;
            }


            const price =
              Number(
                variant.price
              );


            return (
              Number.isFinite(
                price
              ) &&
              price >=
                freeShippingLimit
            );

          };



        /* =================================================
           GALERİ GÖRSELİ BUL
        ================================================= */

        const getGalleryImage =
          (mediaId) => {


            if (
              !mediaId
            ) {

              return null;
            }


            const gallery =
              productRoot.querySelector(
                '[data-dekofar-v2-gallery]'
              );


            if (
              !gallery
            ) {

              return null;
            }



            /* ---------------------------------------------
               MAIN GALLERY
            --------------------------------------------- */

            const galleryItem =
              gallery.querySelector(
                `[data-dekofar-v2-gallery-item][data-media-id="${String(
                  mediaId
                )}"]`
              );


            const galleryImage =
              galleryItem
                ? galleryItem.querySelector(
                    'img'
                  )
                : null;


            if (
              galleryImage
            ) {

              return {
                src:
                  galleryImage.currentSrc ||
                  galleryImage.src ||
                  '',

                srcset:
                  galleryImage.getAttribute(
                    'srcset'
                  ) ||
                  '',

                alt:
                  galleryImage.alt ||
                  ''
              };

            }



            /* ---------------------------------------------
               THUMBNAIL
            --------------------------------------------- */

            const thumbnail =
              gallery.querySelector(
                `[data-dekofar-v2-gallery-thumbnail][data-media-id="${String(
                  mediaId
                )}"]`
              );


            const thumbnailImage =
              thumbnail
                ? thumbnail.querySelector(
                    'img'
                  )
                : null;


            if (
              thumbnailImage
            ) {

              return {
                src:
                  thumbnailImage.currentSrc ||
                  thumbnailImage.src ||
                  '',

                srcset:
                  thumbnailImage.getAttribute(
                    'srcset'
                  ) ||
                  '',

                alt:
                  thumbnailImage.alt ||
                  ''
              };

            }


            return null;

          };



        /* =================================================
           KART GÖRSELİNİ GÜNCELLE
        ================================================= */

        const updateCardMedia =
          (
            button,
            variant
          ) => {


            const mediaWrapper =
              button.querySelector(
                '[data-dekofar-v2-standard-media]'
              );


            if (
              !mediaWrapper ||
              !variant
            ) {

              return;
            }


            if (
              mediaWrapper
                .dekofarV2OriginalHtml ===
              undefined
            ) {

              mediaWrapper
                .dekofarV2OriginalHtml =
                mediaWrapper.innerHTML;

            }



            /* ---------------------------------------------
               MEDIA ID
            --------------------------------------------- */

            let mediaId =
              null;


            if (
              getFeaturedMediaId
            ) {

              mediaId =
                getFeaturedMediaId(
                  variant
                );

            } else if (
              variant.featured_media_id
            ) {

              mediaId =
                variant.featured_media_id;

            }



            /* ---------------------------------------------
               PRODUCT JSON'DA PREVIEW IMAGE VARSA
            --------------------------------------------- */

            let directImage =
              null;


            if (
              variant.featured_media &&
              variant.featured_media.preview_image
            ) {

              directImage =
                variant.featured_media
                  .preview_image;

            }



            /* ---------------------------------------------
               GALERİ IMAGE
            --------------------------------------------- */

            const galleryImage =
              mediaId
                ? getGalleryImage(
                    mediaId
                  )
                : null;


            const imageSrc =
              galleryImage &&
              galleryImage.src
                ? galleryImage.src
                : directImage;


            if (
              !imageSrc
            ) {

              return;
            }


            let image =
              mediaWrapper.querySelector(
                '.dekofar-v2-standard-card__image'
              );


            if (
              !image
            ) {

              mediaWrapper.innerHTML =
                '';


              image =
                document.createElement(
                  'img'
                );


              image.className =
                'dekofar-v2-standard-card__image';


              image.loading =
                'lazy';


              mediaWrapper.appendChild(
                image
              );

            }


            image.src =
              imageSrc;


            if (
              galleryImage &&
              galleryImage.srcset
            ) {

              image.setAttribute(
                'srcset',
                galleryImage.srcset
              );

            } else {

              image.removeAttribute(
                'srcset'
              );

            }


            image.alt =
              galleryImage &&
              galleryImage.alt
                ? galleryImage.alt
                : (
                    variant.title ||
                    productData.title ||
                    ''
                  );

          };



        /* =================================================
           SEÇİLİ KART UI
        ================================================= */

        const updateSelectedCards =
          (selectedValue) => {


            buttons.forEach(
              (button) => {


                const buttonValue =
                  button.getAttribute(
                    'data-dekofar-v2-standard-value'
                  );


                const isSelected =
                  normalizeValue(
                    buttonValue
                  ) ===
                  normalizeValue(
                    selectedValue
                  );


                button.classList.toggle(
                  'is-selected',
                  isSelected
                );


                button.setAttribute(
                  'aria-pressed',
                  isSelected
                    ? 'true'
                    : 'false'
                );

              }
            );


            if (
              selectedValueElement
            ) {

              selectedValueElement
                .textContent =
                selectedValue || '';

            }

          };



        /* =================================================
           TÜM KARTLARI GÜNCELLE
        ================================================= */

        const updateCards =
          () => {


            buttons.forEach(
              (button) => {


                const value =
                  button.getAttribute(
                    'data-dekofar-v2-standard-value'
                  );


                if (
                  !value
                ) {

                  return;
                }


                const variant =
                  findVariantForValue(
                    value
                  );



                /* -----------------------------------------
                   ELEMENTLER

                   DİKKAT:
                   Liquid:
                   data-dekofar-v2-standard-compare-price

                   JS de AYNI attribute'u kullanıyor.
                ----------------------------------------- */

                const priceElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-price]'
                  );


                const compareElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-compare-price]'
                  );


                const discountElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-discount]'
                  );


                const shippingElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-shipping]'
                  );

                const cartCampaignElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-cart-campaign]'
                  );

                const cartCampaignPriceElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-cart-campaign-price]'
                  );

                const cartCampaignBadgeElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-cart-campaign-badge]'
                  );


                const soldOutElement =
                  button.querySelector(
                    '[data-dekofar-v2-standard-sold-out]'
                  );



                /* =========================================
                   VARIANT YOK
                ========================================= */

                if (
                  !variant
                ) {


                  button.disabled =
                    true;


                  button.classList.add(
                    'is-unavailable'
                  );


                  button.setAttribute(
                    'aria-disabled',
                    'true'
                  );


                  button.removeAttribute(
                    'data-dekofar-v2-standard-variant-id'
                  );


                  if (
                    priceElement
                  ) {

                    priceElement.textContent =
                      '';

                  }


                  if (
                    compareElement
                  ) {

                    compareElement.textContent =
                      '';

                    compareElement.hidden =
                      true;

                  }


                  if (
                    discountElement
                  ) {

                    discountElement.textContent =
                      '';

                    discountElement.hidden =
                      true;

                  }


                  if (
                    shippingElement
                  ) {

                    shippingElement.textContent =
                      '';

                    shippingElement.hidden =
                      true;

                  }

                  if (cartCampaignElement) {
                    cartCampaignElement.hidden = true;
                  }

                  if (cartCampaignPriceElement) {
                    cartCampaignPriceElement.textContent = '';
                  }

                  if (priceElement) {
                    priceElement.classList.remove('is-cart-campaign-base');
                  }


                  if (
                    soldOutElement
                  ) {

                    soldOutElement.hidden =
                      false;

                    soldOutElement.textContent =
                      'Stok Yok';

                  }


                  return;

                }



                /* =========================================
                   VARIANT ID
                ========================================= */

                button.setAttribute(
                  'data-dekofar-v2-standard-variant-id',
                  String(
                    variant.id
                  )
                );



                /* =========================================
                   PRICE + CART CAMPAIGN
                ========================================= */

                const currentPrice =
                  Number(variant.price);

                const cartCampaignActive =
                  hasCartDiscountCampaign(currentPrice);

                if (priceElement) {
                  priceElement.textContent = money(currentPrice);
                  priceElement.classList.toggle(
                    'is-cart-campaign-base',
                    cartCampaignActive
                  );
                }

                if (cartCampaignElement) {
                  cartCampaignElement.hidden =
                    !cartCampaignActive;
                }

                if (cartCampaignPriceElement) {
                  cartCampaignPriceElement.textContent =
                    cartCampaignActive
                      ? money(cartDiscountPrice(currentPrice))
                      : '';
                }

                if (cartCampaignBadgeElement) {
                  cartCampaignBadgeElement.textContent =
                    cartCampaignActive
                      ? cartDiscountBadgeText()
                      : '';
                }


                /* =========================================
                   COMPARE PRICE + PRODUCT DISCOUNT
                   Sepet kampanyasında ana vurgu sepetteki
                   son fiyattır; diğer indirim rozeti gizlenir.
                ========================================= */

                let comparePrice = 0;

                if (getCompareAtPrice) {
                  comparePrice =
                    Number(getCompareAtPrice(variant)) || 0;
                } else {
                  comparePrice =
                    Number(variant.compare_at_price || 0);
                }

                const hasComparePrice =
                  Number.isFinite(comparePrice) &&
                  Number.isFinite(currentPrice) &&
                  comparePrice > currentPrice;

                if (compareElement) {
                  compareElement.hidden =
                    cartCampaignActive || !hasComparePrice;

                  compareElement.textContent =
                    (!cartCampaignActive && hasComparePrice)
                      ? money(comparePrice)
                      : '';
                }

                if (discountElement) {
                  if (!cartCampaignActive && hasComparePrice) {
                    const discountPercentage =
                      Math.round(
                        ((comparePrice - currentPrice) /
                          comparePrice) * 100
                      );

                    discountElement.textContent =
                      `%${discountPercentage} AVANTAJ`;
                    discountElement.hidden = false;
                  } else {
                    discountElement.textContent = '';
                    discountElement.hidden = true;
                  }
                }


                /* =========================================
                   STOCK
                ========================================= */

                const isAvailable =
                  Boolean(
                    variant.available
                  );


                button.disabled =
                  !isAvailable;


                button.classList.toggle(
                  'is-unavailable',
                  !isAvailable
                );


                button.setAttribute(
                  'aria-disabled',
                  isAvailable
                    ? 'false'
                    : 'true'
                );


                if (
                  soldOutElement
                ) {

                  soldOutElement.hidden =
                    isAvailable;

                  soldOutElement.textContent =
                    isAvailable ? '' : 'Stok Yok';

                }



                /* =========================================
                   SHIPPING
                ========================================= */

                if (
                  shippingElement
                ) {


                  const freeShipping =
                    variantHasFreeShipping(
                      variant
                    );


                  shippingElement.hidden =
                    !freeShipping;


                  shippingElement.textContent =
                    freeShipping
                      ? '🚚 KARGO BEDAVA'
                      : '';

                }



                /* =========================================
                   IMAGE
                ========================================= */

                updateCardMedia(
                  button,
                  variant
                );

              }
            );

          };



        /* =================================================
           CLICK EVENTLERİ
        ================================================= */

        buttons.forEach(
          (button) => {


            button.addEventListener(
              'click',
              (event) => {


                /*
                 * Kart button olduğu için
                 * form submit ihtimalini kesin engelle.
                 */

                event.preventDefault();
                event.stopPropagation();


                if (
                  button.disabled
                ) {

                  return;
                }


                const value =
                  button.getAttribute(
                    'data-dekofar-v2-standard-value'
                  );


                if (
                  !value
                ) {

                  return;
                }


                /*
                 * Native select içinde gerçekten
                 * bu option var mı kontrol et.
                 */

                const matchingOption = [
                  ...select.options
                ].find(
                  (option) => {

                    return (
                      normalizeValue(
                        option.value
                      ) ===
                      normalizeValue(
                        value
                      )
                    );

                  }
                );


                if (
                  !matchingOption
                ) {

                  console.error(
                    'Dekofar V2 Standard: seçilecek native option bulunamadı:',
                    value
                  );

                  return;
                }



                /* =========================================
                   NATIVE SELECT

                   TEK SOURCE OF TRUTH
                ========================================= */

                select.value =
                  matchingOption.value;



                /* =========================================
                   KART UI ANINDA DEĞİŞSİN
                ========================================= */

                updateSelectedCards(
                  select.value
                );



                /* =========================================
                   CORE JS'E CHANGE EVENT

                   Core:
                   this.updateVariant()

                   çalıştıracaktır.
                ========================================= */

                select.dispatchEvent(
                  new Event(
                    'change',
                    {
                      bubbles: true
                    }
                  )
                );

              }
            );

          }
        );



        /* =================================================
           NATIVE SELECT CHANGE

           Core'dan veya başka modülden değişirse
           Standard UI senkron kalır.
        ================================================= */

        select.addEventListener(
          'change',
          () => {


            updateSelectedCards(
              select.value
            );


            /*
             * Core change listener da aynı eventte çalışır.
             * Bir sonraki frame'de kartların variant
             * verilerini yeniden hesaplamak daha güvenlidir.
             */

            requestAnimationFrame(
              () => {

                updateCards();

              }
            );

          }
        );



        /* =================================================
           DİĞER OPTION SELECTLER DEĞİŞİRSE

           Bir üründe örneğin:
           Model + Basamak
           Renk + Boyut
           vb. olabilir.
        ================================================= */

        allOptionSelects.forEach(
          (otherSelect) => {


            if (
              otherSelect ===
              select
            ) {

              return;
            }


            otherSelect.addEventListener(
              'change',
              () => {


                requestAnimationFrame(
                  () => {

                    updateCards();

                  }
                );

              }
            );

          }
        );



        /* =================================================
           CORE GLOBAL VARIANT EVENT

           Core başarılı variant bulduğunda:
           dekofar:v2:variant-change
        ================================================= */

        productRoot.addEventListener(
          'dekofar:v2:variant-change',
          () => {


            requestAnimationFrame(
              () => {


                updateSelectedCards(
                  select.value
                );


                updateCards();

              }
            );

          }
        );



        /* =================================================
           ARTIK INITIALIZED

           Listenerlar başarılı bağlandıktan sonra işaretle.
        ================================================= */

        selector.dataset
          .dekofarV2StandardInitialized =
          'true';



        /* =================================================
           INITIAL UI
        ================================================= */

        updateSelectedCards(
          select.value
        );


        updateCards();

      }
    );

  }



  /* =======================================================
     PUBLIC API

     dekofar-v2-init.js BUNU ÇAĞIRACAK.
  ======================================================= */

  window.dekofarV2InitStandardOptions =
    dekofarV2InitStandardOptions;


})(
  window,
  document
);